import { DataProvider } from 'react-admin'
import { get, put } from '../common/fetch.utils'
import { EXTERNAL_PARKING_URL } from '../api-urls'
import { CacheableDataProviderExtensionResult } from '../common/data-provider'
import { DiscountDto } from '../dto/external-parking/discount.dto'
import { ParkingRecordDto } from '../dto/external-parking/parking-record.dto'

const provider = {
  getDiscounts: async (
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    resource: string,
  ): Promise<CacheableDataProviderExtensionResult<DiscountDto[]>> => {
    const response = await get<DiscountDto[]>(
      `${EXTERNAL_PARKING_URL}/GetDiscounts`,
    )
    return Promise.resolve({ data: response })
  },
  discount: async (
    resource: string,
    params: DiscountRequest,
  ): Promise<{ data: null }> => {
    await put<DiscountRequest, undefined>(
      `${EXTERNAL_PARKING_URL}/Discount`,
      params,
    )
    return { data: null }
  },
  getRecord: async (
    resource: string,
    params: GetRecordRequest,
  ): Promise<CacheableDataProviderExtensionResult<ParkingRecordDto>> => {
    const response = await get<ParkingRecordDto>(
      `${EXTERNAL_PARKING_URL}/GetRecord/${params?.ticketCode}`,
    )
    return Promise.resolve({ data: response })
  },
  cancel: async (
    resource: string,
    params: CancelRequest,
  ): Promise<{ data: null }> => {
    await put<CancelRequest, undefined>(
      `${EXTERNAL_PARKING_URL}/Cancel`,
      params,
    )
    return { data: null }
  },
} as ExternalParkingProvider

interface ExternalParkingProvider extends DataProvider {
  getDiscounts: (
    resource: string,
  ) => Promise<CacheableDataProviderExtensionResult<DiscountDto[]>>

  discount: (
    resource: string,
    params: DiscountRequest,
  ) => Promise<{ data: null }>

  getRecord: (
    resource: string,
    params: GetRecordRequest,
  ) => Promise<CacheableDataProviderExtensionResult<ParkingRecordDto>>

  cancel: (resource: string, params: CancelRequest) => Promise<{ data: null }>
}

export interface DiscountRequest {
  readonly discountId: number
  readonly ticketCode: string | null
}

export interface GetRecordRequest {
  readonly ticketCode: string
}

export interface CancelRequest {
  readonly ticketCode: string | null
  readonly updateCounters: boolean
}

export default provider
